import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = {
  key: 0,
  class: "h2 mb-3 text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Räkna på bolån", -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "justify-content-center row my-3" }
const _hoisted_7 = {
  key: 0,
  class: "col-sm-6 col-md-4 d-grid"
}
const _hoisted_8 = { class: "col-sm-6 col-md-4 d-grid" }
const _hoisted_9 = { class: "card card-feat" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "col-auto" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = { class: "card card-feat" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "mt-4" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageTopMenu = _resolveComponent("MortgageTopMenu")!
  const _component_MortgageCalculation = _resolveComponent("MortgageCalculation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.app.showMortgageCalculationForCanceledApp)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, " Välkommen till Ordna Bolån "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_MortgageTopMenu, {
            showFoundProperty: 
          _ctx.app.purpose == 'PromissoryLetter' || _ctx.app.findProperty
        ,
            showMortgageCalculator: true,
            active: "Räkna på bolån"
          }, null, 8, ["showFoundProperty"])
        ])),
    (_ctx.app.showMortgageCalculationForCanceledApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.app.applicationId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage('CalculateCosts'))),
                    class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'CalculateCosts' }])
                  }, " Ansök om lånelöfte ", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage('CalculateInterest'))),
                class: _normalizeClass(["btn btn-light mb-2", { active: _ctx.currentPage == 'CalculateInterest' }])
              }, " Flytta bolån ", 2)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.currentPage == 'CalculateInterest')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_MortgageCalculation, {
                          app: _ctx.app,
                          calculationType: "CalculateInterest"
                        }, null, 8, ["app"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentPage == 'CalculateCosts')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_MortgageCalculation, {
                          app: _ctx.app,
                          calculationType: "CalculateCosts"
                        }, null, 8, ["app"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_ctx.app.offerIsPremiumBank)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["row gx-2", {'justify-content-center': _ctx.isMobileDevice == true}])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage('CalculateCosts'))),
                    class: _normalizeClass(["calculation-btn", { active: _ctx.currentPage == 'CalculateCosts' }])
                  }, " Räkna kostnad ", 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage('CalculateInterest'))),
                    class: _normalizeClass(["calculation-btn", { active: _ctx.currentPage == 'CalculateInterest' }])
                  }, " Räkna ränta ", 2)
                ])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.currentPage == 'CalculateInterest')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_MortgageCalculation, {
                        app: _ctx.app,
                        calculationType: "CalculateInterest"
                      }, null, 8, ["app"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentPage == 'CalculateCosts')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_MortgageCalculation, {
                        app: _ctx.app,
                        calculationType: "CalculateCosts"
                      }, null, 8, ["app"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
  ]))
}